import { Category } from "senac-components/dist/pages/Mobile/PageInterfaces";

export const hasCategory = (uid: string, rootCategories: Category[]): boolean => {
    var result =
      rootCategories.find((category) => findCategory(uid, category)) != undefined;
    return result;
  };
  
export const findCategory = (
    uid: string,
    rootCategory: Category
  ): Category | undefined => {
    if (rootCategory.uid === uid) return rootCategory;
  
    for (const child of rootCategory.childs ?? []) {
      if (child.uid === uid) return child;
  
      var foundInChilds = findCategory(uid, child);
      if (foundInChilds) return foundInChilds;
    }
  
    return undefined;
  };